import { userService } from "../services";
import config from "../config/config";

export const ClientAction = {
  uploadFile,
  getAddressFromGoogleMap,
  getHrmsUsers,
  fetchClientDetails,
  fetchImportExcel,
  fetchLocalityList,
  exportUserExcel,
  fetchRouteMode,
  updateUserRouteMode,
};

async function uploadFile(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.uploadFile}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getAddressFromGoogleMap(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.getAddressFromGoogleMap}?lat=${payload.lat}&lon=${payload.lng}`;
  const response = await userService.get(apiEndpoint);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getHrmsUsers(payload) {
  let apiEndpoint = payload.siteId
    ? `${config.baseUrl}${config.apiName.getHrmsUsers}?token=${payload.hrmsToken}&hrmsUserId=${payload.hrmsUserId}&userId=${payload.userId}&siteId=${payload.siteId}`
    : `${config.baseUrl}${config.apiName.getHrmsUsers}?token=${payload.hrmsToken}&hrmsUserId=${payload.hrmsUserId}&userId=${payload.userId}`;
  const response = await userService.get(apiEndpoint);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function fetchClientDetails(payload) {
  // payload is userId
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.clientDetails}?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchImportExcel(payload) {
  // payload is userId
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ImportClient}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchLocalityList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.localityList}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function exportUserExcel(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.exportUser}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchRouteMode(payload) {
  let apiEndpoint = config.baseUrl+config.apiName.getRouteMode;
  const response = await userService.get(apiEndpoint);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function updateUserRouteMode(payload) {
  let apiEndpoint = config.baseUrl+config.apiName.updateUserRouteMode;
  const response = await userService.post(apiEndpoint, payload);
  if (response && response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}
